import { ValueOf } from '@/types/util';

export const EEntryStatus = {
  NOT_STARTED: '申込予定',
  OPEN: '申込受付中',
  ENDED: '申込終了',
} as const;

export type EntryStatusKey = keyof typeof EEntryStatus;
export type EntryStatusValue = ValueOf<typeof EEntryStatus>;

export const entryStatusKeys = Object.keys(EEntryStatus) as EntryStatusKey[];

/** v-select用items */
export const entryStatusItems = entryStatusKeys
  .map((key) => ({
    title: EEntryStatus[key],
    value: key,
  }));
